import React from 'react';
import { Modal } from 'antd';

export default function AntModal(props) {
  return <Modal {...props} />;
}
